import BaseService from '../BaseService';

class GroupService extends BaseService {
    getAll = (filters) => this.post('/warehouse/groups', filters || { });

    getOne = (id) => this.get(`/warehouse/group/${id}`);

    deleteOne = (id) => this.delete(`/warehouse/group/${id}`);

    addGroup = (data) => this.post('/warehouse/group', data);

    editGroup = (id, data) => this.put(`/warehouse/group/${id}`, data);
}

export default new GroupService();